import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-key-value-table',
  templateUrl: './key-value-table.component.html',
  styleUrls: ['./key-value-table.component.scss'],
})
export class KeyValueTableComponent implements OnChanges {
  @Input() tableTitle: string;
  @Input() tableJsonData: Object;

  public keys: any;
  public values: any;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.tableJsonData) {
      const tableJsonDataChange = changes.tableJsonData;
      if (tableJsonDataChange.currentValue) {
        this.tableJsonData = tableJsonDataChange.currentValue;
        this.keys = Object.keys(this.tableJsonData);
        this.values = Object.values(this.tableJsonData);
      }
    }
  }
}
